var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSection2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 297,
    viewBox: "0 0 340 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 225.304,
    y: 159.484,
    width: 20,
    height: 9,
    transform: "rotate(130.178 225.304 159.484)",
    fill: "#62bcf8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151.191,
    y: 96.9038,
    width: 20,
    height: 9,
    transform: "rotate(130.178 151.191 96.9038)",
    fill: "#62bcf8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 157.218,
    y: 75.8164,
    width: 20,
    height: 9,
    transform: "rotate(130.178 157.218 75.8164)",
    fill: "#62bcf8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.6,
    y: 55.4932,
    width: 19,
    height: 9,
    transform: "rotate(130.178 162.6 55.4932)",
    fill: "#62bcf8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.412,
    y: 106.378,
    width: 20,
    height: 9,
    transform: "rotate(130.178 131.412 106.378)",
    fill: "#62bcf8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.632,
    y: 115.853,
    width: 20,
    height: 9,
    transform: "rotate(130.178 111.632 115.853)",
    fill: "#62bcf8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8525,
    y: 125.327,
    width: 5,
    height: 5,
    transform: "rotate(130.178 91.8525 125.327)",
    fill: "#62bcf8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159.595,
    y: 45.1025,
    width: 6,
    height: 5,
    transform: "rotate(130.178 159.595 45.1025)",
    fill: "#62bcf8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 224.233,
    y: 146.802,
    width: 9,
    height: 20,
    transform: "rotate(130.178 224.233 146.802)",
    fill: "#62bcf8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 218.428,
    y: 153.678,
    width: 9,
    height: 88,
    transform: "rotate(130.178 218.428 153.678)",
    fill: "#62bcf8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 208.953,
    y: 133.898,
    width: 9,
    height: 77,
    transform: "rotate(130.178 208.953 133.898)",
    fill: "#62bcf8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 199.479,
    y: 114.119,
    width: 9,
    height: 57,
    transform: "rotate(130.178 199.479 114.119)",
    fill: "#62bcf8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 190.004,
    y: 94.3389,
    width: 7,
    height: 46,
    transform: "rotate(130.178 190.004 94.3389)",
    fill: "#62bcf8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 185.488,
    y: 99.6875,
    width: 2,
    height: 37,
    transform: "rotate(130.178 185.488 99.6875)",
    fill: "#62bcf8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 180.529,
    y: 74.5596,
    width: 9,
    height: 26,
    transform: "rotate(130.178 180.529 74.5596)",
    fill: "#62bcf8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 171.056,
    y: 54.7798,
    width: 9,
    height: 6,
    transform: "rotate(130.178 171.056 54.7798)",
    fill: "#62bcf8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 171.056,
    y: 54.7798,
    width: 6,
    height: 15,
    transform: "rotate(130.178 171.056 54.7798)",
    fill: "#62bcf8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 88,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 205.524 168.959)",
    fill: "#62bcf8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 77,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 183.792 163.696)",
    fill: "#62bcf8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 57,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 163.35 156.905)",
    fill: "#62bcf8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 46,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 142.262 150.878)",
    fill: "#62bcf8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 37,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 146.778 145.53)",
    fill: "#62bcf8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 26,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 120.529 145.616)",
    fill: "#62bcf8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 6,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 98.1514 141.117)",
    fill: "#62bcf8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15,
    transform: "matrix(0.645163 -0.764045 -0.764045 -0.645163 100.087 138.825)",
    fill: "#62bcf8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 205.524,
    y: 168.959,
    width: 9,
    height: 20,
    transform: "rotate(130.178 205.524 168.959)",
    fill: "#62bcf8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 184.437,
    y: 162.932,
    width: 9,
    height: 20,
    transform: "rotate(130.178 184.437 162.932)",
    fill: "#62bcf8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 163.35,
    y: 156.905,
    width: 9,
    height: 20,
    transform: "rotate(130.178 163.35 156.905)",
    fill: "#62bcf8"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 142.262,
    y: 150.878,
    width: 9,
    height: 20,
    transform: "rotate(130.178 142.262 150.878)",
    fill: "#62bcf8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 121.175,
    y: 144.852,
    width: 9,
    height: 20,
    transform: "rotate(130.178 121.175 144.852)",
    fill: "#62bcf8"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 100.087,
    y: 138.825,
    width: 9,
    height: 20,
    transform: "rotate(130.178 100.087 138.825)",
    fill: "#62bcf8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 214.76,
    y: 127.022,
    width: 9,
    height: 20,
    transform: "rotate(130.178 214.76 127.022)",
    fill: "#62bcf8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 205.285,
    y: 107.242,
    width: 9,
    height: 20,
    transform: "rotate(130.178 205.285 107.242)",
    fill: "#62bcf8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 195.811,
    y: 87.4629,
    width: 9,
    height: 20,
    transform: "rotate(130.178 195.811 87.4629)",
    fill: "#62bcf8"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 186.336,
    y: 67.6831,
    width: 9,
    height: 20,
    transform: "rotate(130.178 186.336 67.6831)",
    fill: "#62bcf8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 176.861,
    y: 47.9033,
    width: 9,
    height: 20,
    transform: "rotate(130.178 176.861 47.9033)",
    fill: "#62bcf8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#62bcf8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 264.522,
    y: 179,
    width: 12,
    height: 12,
    transform: "rotate(27.4009 264.522 179)",
    fill: "#62bcf8"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 33,
    width: 12,
    height: 12,
    fill: "#62bcf8"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 303.492,
    y: 236.371,
    width: 12,
    height: 12,
    transform: "rotate(27.4009 303.492 236.371)",
    fill: "#62bcf8"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 33,
    width: 12,
    height: 12,
    fill: "#62bcf8"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 329.238,
    y: 249.717,
    width: 12,
    height: 12,
    transform: "rotate(27.4009 329.238 249.717)",
    fill: "#62bcf8"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 68,
    width: 12,
    height: 12,
    fill: "#62bcf8"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 313.131,
    y: 280.791,
    width: 12,
    height: 12,
    transform: "rotate(27.4009 313.131 280.791)",
    fill: "#62bcf8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSection2);
export default __webpack_public_path__ + "static/media/arrow-section-2.b464461deeb3c1d07d56d3be5c632e76.svg";
export { ForwardRef as ReactComponent };